import clsx from "clsx";
import { Link } from "react-router-dom";
import { SectionTitle, Subtitle } from "components/atoms/Text";

const BuyProxies = () => {
    return (
        <section className="features w-full bg-primary-dark">
            <div className="w-full relative max-w-[1440px] mx-auto phone:py-12 tablet:py-[72px] py-[112px] overflow-hidden">
                <img src="/images/homepage/buyproxies/brick.svg" className="absolute tablet:top-[40px] tablet:right-[49px] tablet:w-[141px] tablet:h-[157px] phone:top-[18px] phone:w-[93px] phone:h-[103px] top-[31px] phone:-right-[32px] right-[131px]" width="194px" height="216px" alt="brick" />
                <img src="/images/homepage/buyproxies/brick-sm.svg" className="absolute tablet:left-[33px] tablet:w-[151px] tablet:h-[168px] tablet:bottom-[-15px] bottom-0 phone:bottom-[-40px] phone:left-[24px] phone:w-[103px] phone:h-[114px] left-[120px]" width="194px" height="216px" alt="brick" />
                <section className={clsx(
                    "w-full mx-auto max-w-full tablet:max-w-[433px] desktop:max-w-[503px] text-center",
                    "px-6 md:px-0"
                )}>
                    <SectionTitle isLight classNames="tablet:!text-[40px]">Buy Proxies Now</SectionTitle>
                    <Subtitle classNames="phone:!text-[16px]">HTTP Proxies or SOCKS, Shared or Dedicated, Premium or Non-Premium, we have them all.</Subtitle>
                    <div className="w-full mx-auto flex flex-col md:flex-row md:items-center justify-center md:space-x-6 space-y-4 md:space-y-0 mt-10 phone:mt-8">
                        <Link to="/auth/signin" className="relative z-30">
                            <button className="h-[56px] flex items-center justify-center w-full md:w-fit px-[45.5px] font-semibold rounded-lg bg-primary-main hover:bg-primary-hover text-md text-basier-circle-semibold text-neutral-10">Buy Proxy</button>
                        </Link>
                        <button className="h-[56px] flex items-center justify-center w-full md:w-fit px-[45.5px] font-semibold rounded-lg text-primary-main text-md text-basier-circle-semibold bg-primary-surface">Buy VPN</button>
                    </div>
                </section>
            </div>
        </section>
    );
};

export default BuyProxies;